import ProductCategoryPage from "../components/ProductCategoryPage.js";

export default function ExoticImportedMarble() {
  return (
    <ProductCategoryPage
      category="Highlighter"
      seoTitle="Best Exotic Highlighter Imported Marble Collection In Kishangarh India | Premium Highlighter Marble"
      seoDescription="Discover rare exotic highlighter imported marble slabs for premium interiors. Explore our exclusive collection of highlighter marble in Kishangarh India. Contact Square Feet Marble today!  "
      canonical="https://www.squarefeetmarble.com/exotic-imported-marble-kishangarh.webp"
    />
  );
}
